import React, { lazy, useEffect } from 'react'
import { FrontUrls } from 'Constants/FrontUrls'
import { Route, Switch } from 'react-router-dom'
import { useAppDispatch } from 'Src/hooks'
import { RegistratorCabinetLogsRoutes } from 'Pages/registratorCabinet'
import { SocketChannel, socketSlice } from 'Modules/Socket'
import { filtersSlice, LazyRoute, PAGE_SLUG } from 'Modules'

const RegistratorCabinetOrderListLazy = lazy(
	() => import('Pages/registratorCabinet/components/OrdersList/List/OrderList')
)
const RegistratorCabinetOrderCreateLazy = lazy(
	() => import('Pages/registratorCabinet/components/OrdersCreate')
)
const RegistratorCabinetOrderEditLazy = lazy(
	() => import('Pages/registratorCabinet/components/OrdersForm/OrderEditForms/OrderEditForm')
)

const actions = {
	clearFilters: filtersSlice.actions.clearFilters,
	subscribeChannels: socketSlice.actions.subscribeChannels,
	unsubscribeChannels: socketSlice.actions.unSubscribeChannels,
}

export const DesktopRegistratorCabinetRoutes = () => {
	const { clearFilters, subscribeChannels, unsubscribeChannels } = useAppDispatch(actions)
	useEffect(() => {
		subscribeChannels([
			SocketChannel.CUSTOMER_IDENTIFICATION_CHANNEL,
			SocketChannel.RBIDOS_REQUEST_CHANNEL,
		])
		return () => {
			clearFilters(PAGE_SLUG.REGISTRATION_OFFICE_REDESIGN)
			unsubscribeChannels([
				SocketChannel.CUSTOMER_IDENTIFICATION_CHANNEL,
				SocketChannel.RBIDOS_REQUEST_CHANNEL,
			])
		}
	}, [])

	return (
		<Switch>
			<LazyRoute
				exact
				path={FrontUrls.cabinet_redesign.cabinet}
				lazyComponent={RegistratorCabinetOrderListLazy}
				key={FrontUrls.cabinet_redesign.cabinet}
			/>
			<LazyRoute
				exact
				path={FrontUrls.cabinet_redesign.order_create}
				lazyComponent={RegistratorCabinetOrderCreateLazy}
				key={FrontUrls.cabinet_redesign.order_create}
			/>
			<LazyRoute
				exact
				path={FrontUrls.cabinet_redesign.order_edit}
				lazyComponent={RegistratorCabinetOrderEditLazy}
				key={FrontUrls.cabinet_redesign.order_edit}
			/>
			<Route
				path={FrontUrls.cabinet_redesign.logs}
				key={FrontUrls.cabinet_redesign.logs}
				component={RegistratorCabinetLogsRoutes}
			/>
		</Switch>
	)
}
